import { assert } from '@ember/debug';
import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class AtomsFormsRangePillsIndexComponent extends Component {
  @action
  propagateInputChange(val) {
    if (!this.args?.onInputChange)
      assert(
        'A callback function needs to be passed to propagate selected input',
        false,
      );
    this.args?.onInputChange?.(val);
  }

  get value() {
    const val = +this.args.value;
    return isNaN(val) ? 0 : val;
  }
}
